import { render, staticRenderFns } from "./LabelHeaderEditForm.vue?vue&type=template&id=bf11b002&scoped=true&"
import script from "./LabelHeaderEditForm.vue?vue&type=script&lang=ts&"
export * from "./LabelHeaderEditForm.vue?vue&type=script&lang=ts&"
import style0 from "./LabelHeaderEditForm.vue?vue&type=style&index=0&id=bf11b002&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf11b002",
  null
  
)

export default component.exports